"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("alpinejs");
var react_1 = __importDefault(require("react"));
var util_1 = require("./util");
var react_dom_1 = require("react-dom");
var SearchIndex_1 = __importDefault(require("./components/SearchIndex"));
var Provinces_1 = __importDefault(require("./components/Provinces"));
var AutoComplete_1 = __importDefault(require("./components/AutoComplete"));
var react_instantsearch_dom_1 = require("react-instantsearch-dom");
var lite_1 = __importDefault(require("algoliasearch/lite"));
var translator_1 = require("./translations/translator");
var GeoSearch_1 = __importDefault(require("./components/GeoSearch"));
var leaflet_geosearch_1 = require("leaflet-geosearch");
var lodash_1 = require("lodash");
window.__ = function (string, replacements) {
    return translator_1.translate(string, replacements);
};
window.__n = function (string, number, replacements) {
    return translator_1.translateChoice(string, number, replacements);
};
util_1.$$('[data-search]').forEach(function (searchIndex) {
    var latlng = null;
    if (searchIndex.dataset['latlng']) {
        var _a = searchIndex.dataset['latlng'].split(','), lat = _a[0], lng = _a[1];
        latlng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng),
        };
    }
    react_dom_1.render(react_1.default.createElement(SearchIndex_1.default, { latlng: latlng, path: searchIndex.dataset['path'] }, searchIndex.innerHTML), searchIndex);
});
util_1.$$('[data-autocomplete]').forEach(function (autocomplete) {
    var searchClient = lite_1.default(window.Algolia.app_id, window.Algolia.search_key);
    react_dom_1.render(react_1.default.createElement(react_instantsearch_dom_1.InstantSearch, { searchClient: searchClient, indexName: window.Algolia.index_name },
        react_1.default.createElement(react_instantsearch_dom_1.Configure, { hitsPerPage: 5, filters: "locale:" + window.locale }),
        react_1.default.createElement(AutoComplete_1.default, null)), autocomplete);
});
util_1.$$('[data-province-tabs]').forEach(function (provinceTabs) {
    react_dom_1.render(react_1.default.createElement(Provinces_1.default, null), provinceTabs);
});
util_1.$$('[data-notification]').forEach(function (notification) {
    var id = notification.dataset.notification || '';
    if (!localStorage.getItem(id)) {
        notification.classList.remove('hidden');
    }
    util_1.$$('[data-notification-close]', notification).forEach(function (closeLink) {
        closeLink.addEventListener('click', function (e) {
            e.preventDefault();
            notification.classList.add('hidden');
            localStorage.setItem(id, '1');
        });
    });
});
util_1.$$('[data-geosearch-display]').forEach(function (geosearchDisplay, index) {
    react_dom_1.render(react_1.default.createElement(GeoSearch_1.default, { key: index }), geosearchDisplay);
});
var provider = new leaflet_geosearch_1.OpenStreetMapProvider();
util_1.$$('[data-places-input]').forEach(function (placesInput) {
    placesInput.addEventListener('input', lodash_1.debounce(function (changeEvent) {
        var _a, _b, _c, _d, _e;
        var target = changeEvent.target;
        (_b = (_a = placesInput.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('button')) === null || _b === void 0 ? void 0 : _b.setAttribute('disabled', 'disabled');
        (_d = (_c = placesInput.parentElement) === null || _c === void 0 ? void 0 : _c.querySelector('button')) === null || _d === void 0 ? void 0 : _d.classList.add('disabled');
        (_e = placesInput.parentElement) === null || _e === void 0 ? void 0 : _e.setAttribute('disabled', 'disabled');
        provider.search({ query: target.value + ', Belgium' }).then(function (results) {
            var _a, _b, _c, _d, _e;
            (_a = placesInput.parentElement) === null || _a === void 0 ? void 0 : _a.removeAttribute('disabled');
            (_c = (_b = placesInput.parentElement) === null || _b === void 0 ? void 0 : _b.querySelector('button')) === null || _c === void 0 ? void 0 : _c.removeAttribute('disabled');
            (_e = (_d = placesInput.parentElement) === null || _d === void 0 ? void 0 : _d.querySelector('button')) === null || _e === void 0 ? void 0 : _e.classList.remove('disabled');
            results = results.filter(function (result) { return ['boundary', 'place'].includes(result.raw.class); });
            if (!results.length) {
                return;
            }
            var input = util_1.$('[data-places-value]');
            input.value = results[0].y + ',' + results[0].x;
        });
    }, 200));
});
